import { render } from "./ParametresPharmaciePage.vue?vue&type=template&id=0697ab0a&scoped=true&ts=true"
import script from "./ParametresPharmaciePage.vue?vue&type=script&lang=ts"
export * from "./ParametresPharmaciePage.vue?vue&type=script&lang=ts"

import "./ParametresPharmaciePage.vue?vue&type=style&index=0&id=0697ab0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0697ab0a"]])

export default __exports__